
const WhyChooseUs = () => {
  const features = [
    {
      icon: 'ri-shield-check-fill',
      title: 'Reliable',
      description: 'Licensed and insured electrical contractors with years of experience in the GTA area.'
    },
    {
      icon: 'ri-time-fill',
      title: 'Fast Service',
      description: '24/7 emergency electrical services with quick response times for urgent electrical issues.'
    },
    {
      icon: 'ri-heart-fill',
      title: 'Trusted Locally',
      description: 'Proudly serving Oshawa and surrounding areas with honest, transparent electrical solutions.'
    },
    {
      icon: 'ri-award-fill',
      title: 'Quality Work',
      description: 'Professional electrical installations and repairs that meet all safety codes and standards.'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Why Choose <span className="text-yellow-600">OhmEx Electric</span>?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We're committed to providing exceptional electrical services with professionalism, 
            reliability, and customer satisfaction as our top priorities.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
              <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center mb-4">
                <i className={`${feature.icon} text-yellow-600 text-xl`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
